import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private isCollapsedSubject = new BehaviorSubject<boolean>(false);
  public isCollapsed$ = this.isCollapsedSubject.asObservable();

  constructor() { }

  toggleSideMenu(): void {
    const currentState = this.isCollapsedSubject.value;
    this.isCollapsedSubject.next(!currentState);
  }

  getIsCollapsed(): boolean {
    return this.isCollapsedSubject.value;
  }

  setIsCollapsed(collapsed: boolean): void {
    this.isCollapsedSubject.next(collapsed);
  }

  resetMenuState(): void {
    this.isCollapsedSubject.next(false);
  }
}
